import React from "react";
import { Eye, Pencil, Send, Trash2 } from "lucide-react";
import IconAction from "../../../components/IconAction";

// Row actions of the Channel list. Send test, Edit and Delete are Super Admin only (`canManage`);
// Send test is offered for channels that can deliver now. `busy` = { id, action } of a request in flight.
export default function ChannelRowActions({ row, canManage, busy, onView, onTestSend, onEdit, onDelete }) {
  const anyBusy = busy?.id === row.id;
  return (
    <div className="flex items-center gap-1">
      <IconAction label="View" icon={Eye} onClick={() => onView(row)} disabled={anyBusy} />
      {canManage && (
        <>
          {row.phase === 1 && <IconAction label="Send a test to me" icon={Send} onClick={() => onTestSend(row)} busy={anyBusy && busy.action === "test"} disabled={anyBusy} />}
          <IconAction label="Edit" icon={Pencil} tone="primary" onClick={() => onEdit(row)} disabled={anyBusy} />
          <IconAction label="Delete" icon={Trash2} tone="danger" onClick={() => onDelete(row)} disabled={anyBusy} />
        </>
      )}
    </div>
  );
}
